import React from 'react';
import { Route, NotFound } from 'cccisd-laravel-boilerplate';
import defaultProps from 'recompose/defaultProps.js';
import { Switch } from 'react-router-dom';
import { AdminRoutes, Manage as AppdefManage } from 'cccisd-laravel-appdefs';
import { AuthRedirect } from 'cccisd-laravel-nexus';
import { EndpointEvaluator, Quest } from 'cccisd-laravel-assignment';
import { ResourceCenter } from 'cccisd-laravel-resources';

// Layouts
import MainLayout from './layouts/MainLayout';
import QuestLayout from './layouts/QuestLayout';

// Pages
/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved */
import Welcome from './pages/Welcome';
import Register from './pages/Register';
import Product from './pages/Product';
import Interventions from './pages/Interventions';

// Laravel packages
import Nexus from 'bundle-loader?lazy!cccisd-laravel-nexus';
import Licensing from 'bundle-loader?lazy!cccisd-laravel-licensing';

// Bind MainLayout by default
const AppRoute = defaultProps({ layout: MainLayout })(Route);

const MainLayoutFluid = defaultProps({ className: 'container-fluid' })(MainLayout);
const MainLayoutSecondaryNav = defaultProps({ showSecondaryNav: true })(MainLayout);
const MainLayoutFluidSecondaryNav = defaultProps({
    className: 'container-fluid',
    showSecondaryNav: true,
})(MainLayout);

let Fortress = window.cccisd.fortress;
let AppDefinitions = window.cccisd.appDefs;

const componentMatch = {
    AppdefManage,
    Welcome,
    ResourceCenter,
};

const layoutMatch = {
    MainLayout,
    MainLayoutFluid,
    MainLayoutSecondaryNav,
    MainLayoutFluidSecondaryNav,
};

export default () => (
    <Switch>
        {AppDefinitions.routes.map(route => {
            const Component = componentMatch[route.componentHandle];
            if (!Component) {
                return null;
            }

            return (
                <AppRoute
                    key={route.handle}
                    path={route.url}
                    component={Component}
                    componentProps={route.componentProps}
                    exact
                    layout={
                        'layout' in route && layoutMatch[route.layout] ? layoutMatch[route.layout] : MainLayoutFluid
                    }
                />
            );
        })}
        <AppRoute path="/" component={Welcome} exact />
        <AppRoute path="/welcome" component={Welcome} />
        <AppRoute path="/login" component={Register} />
        <AppRoute path="/register" component={Register} />

        <AppRoute path="/product/:productHandle" exact component={Product} />
        <AppRoute path="/licensing" component={Licensing} componentProps={{ renderAuthRedirect: () => <Register /> }} />
        <AppRoute
            path="/interventions"
            component={Interventions}
            componentProps={{ handle: 'interventions', key: 'interventions' }}
        />
        <AppRoute
            path="/resources_public/:tab?/:id?"
            component={ResourceCenter}
            componentProps={{ handle: 'resources_public', key: 'resources_public' }}
        />
        <AppRoute
            path="/news/:tab?/:id?"
            component={ResourceCenter}
            componentProps={{ handle: 'News_public', key: 'News_public' }}
        />
        <AppRoute
            path="/research/:tab?/:id?"
            component={ResourceCenter}
            componentProps={{ handle: 'Research_public', key: 'Research_public' }}
        />

        <AppRoute exact path="/course/:endpoint/:shortHash?" component={EndpointEvaluator} />
        <AppRoute
            path={['/quest/preview', '/d', '/survey']}
            component={Quest}
            componentProps={{
                errorLayout: MainLayoutSecondaryNav,
                registrationUrlsByRole: {
                    learner: '/register',
                },
            }}
            layout={QuestLayout}
        />

        {/* Laravel packages routes */}
        {AdminRoutes(MainLayoutFluid)}

        <AppRoute path="/account" component={Nexus} />

        <AppRoute path={Fortress.settings.config.after_login_url} component={AuthRedirect} exact />

        {/* Not found page */}
        <AppRoute component={NotFound} />
    </Switch>
);
